<template>
  <div id="review-header">
    <div
        v-if="this.review.polarity === 'Positief'"
        class="experience-header positive"
    >
      <div class="experience-polarity-relevance-container">
        <div class="experience-title">
          <div class="experience-title-container">
            <font-awesome-icon
                v-if="review.organisation.state.favorite === 1"
                class="state-icon"
                icon="heart"
            />
            <font-awesome-icon
                v-if="review.organisation.state.exact === 1"
                class="state-icon"
                icon="briefcase"
            />
            <font-awesome-icon
                v-if="review.organisation.state.urgent === 1"
                class="state-icon"
                icon="exclamation"
            />
            <router-link
                :to="{ path: '/company/' + review.organisation.id }"
                class="nav-link-experience-title"
            >
              {{ review.organisation.name }}
            </router-link>
          </div>
        </div>
        <ReviewMenu :review="review"></ReviewMenu>
      </div>
    </div>
    <div
        v-if="review.polarity === 'Negatief'"
        class="experience-header negative"
    >
      <div class="experience-polarity-relevance-container">
        <div class="experience-title">
          <div class="experience-title-container">
            <font-awesome-icon
                v-if="review.organisation.state.favorite === 1"
                class="state-icon"
                icon="heart"
            />
            <font-awesome-icon
                v-if="review.organisation.state.exact === 1"
                class="state-icon"
                icon="briefcase"
            />
            <font-awesome-icon
                v-if="review.organisation.state.urgent === 1"
                class="state-icon"
                icon="exclamation"
            />
            <router-link
                :to="{ path: '/company/' + review.organisation.id }"
                class="nav-link-experience-title"
            >
              {{ review.organisation.name }}
            </router-link>
          </div>
        </div>
        <ReviewMenu :review="review"></ReviewMenu>
      </div>
    </div>
    <div
        v-if="review.polarity === 'Neutraal' && review.graded === 1"
        class="experience-header neutral"
    >
      <div class="experience-polarity-relevance-container">
        <div class="experience-title">
          <div class="experience-title-container">
            <font-awesome-icon
                v-if="review.organisation.state.favorite === 1"
                class="state-icon"
                icon="heart"
            />
            <font-awesome-icon
                v-if="review.organisation.state.exact === 1"
                class="state-icon"
                icon="briefcase"
            />
            <font-awesome-icon
                v-if="review.organisation.state.urgent === 1"
                class="state-icon"
                icon="exclamation"
            />
            <router-link
                :to="{ path: '/company/' + review.organisation.id }"
                class="nav-link-experience-title"
            >
              {{ review.organisation.name }}
            </router-link>
          </div>
        </div>
        <ReviewMenu :review="review"></ReviewMenu>
      </div>
    </div>
    <div v-if="review.graded === 0" class="experience-header notGraded">
      <div class="experience-polarity-relevance-container notGraded">
        <div class="experience-title">
          <div class="experience-title-container">
            <font-awesome-icon
                v-if="review.organisation.state.favorite === 1"
                class="state-icon"
                icon="heart"
            />
            <font-awesome-icon
                v-if="review.organisation.state.exact === 1"
                class="state-icon"
                icon="briefcase"
            />
            <font-awesome-icon
                v-if="review.organisation.state.urgent === 1"
                class="state-icon"
                icon="exclamation"
            />
            <router-link
                :to="{ path: '/company/' + review.organisation.id }"
                class="nav-link-experience-title notGraded"
            >
              {{ review.organisation.name }}
            </router-link>
          </div>
        </div>
        <ReviewMenu :review="review"></ReviewMenu>
      </div>
    </div>
  </div>
</template>

<script>
import ReviewMenu from "@/components/ReviewMenu.vue";

export default {
  name: "ReviewHeader",
  props: {
    review: Object,
  },
  components: {
    ReviewMenu,
  },
  methods: {
    updateParent() {
      this.$parent.updateParent();
    },
  },
};
</script>
